import { createModel, RematchDispatch } from '@rematch/core';
import * as userContactApi from '../../services/cmsUserContact.service';
import { CMSUserContactType } from '../../types/CMSUserContactTypes';
import { PaginationType } from '../../types/CommonTypes';
import { RootModel } from '../models';
import baseEntity from './base.entity';

export const storeName = 'cmsUserContactEntity';

export const cmsUserContactEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof cmsUserContactEntity>) => ({
    async load(payload): Promise<{ content: CMSUserContactType[] } & PaginationType> {
      try {
        const res = await userContactApi.filter(payload);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async findById(payload, state) {
      try {
        const item = state[storeName].ids[payload];
        if (item && !item.isSimplified) {
          return item;
        }
        const res = await userContactApi.getById(payload);
        this.update(res.data);
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(payload) {
      try {
        await userContactApi.deleteById(payload);
        this.remove({ id: payload });
      } catch (e) {
        throw new Error(e);
      }
    },
    async save(payload) {
      try {
        let item;
        if (!payload.id) {
          ({ data: item } = await userContactApi.create(payload));
        } else {
          ({ data: item } = await userContactApi.update(payload.id, payload));
        }
        this.update(item);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
    async publish(payload) {
      try {
        const { data: item } = await userContactApi.publish(payload);
        this.update(item);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
    async loadPublished(): Promise<{ content: CMSUserContactType[] } & PaginationType> {
      try {
        const res = await userContactApi.filterPublished();
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default cmsUserContactEntity;
